import CloseIcon from "@mui/icons-material/Close";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

export default function HubUsageSelectionFilterDialog({
    items,
    onClose,
    onToggle,
    onToggleAll,
    open,
    selectedKeys,
    title,
}) {
    const allSelected =
        items.length > 0 && selectedKeys.length === items.length;

    return (
        <Dialog
            onClose={onClose}
            open={open}
            fullWidth
            maxWidth="xs"
            aria-labelledby="hub-usage-filter-title"
            slotProps={{
                paper: { sx: { borderRadius: 3, overflow: "hidden" } },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.5,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2,
                        display: "grid",
                        placeItems: "center",
                        color: "primary.main",
                        backgroundColor: "action.hover",
                    }}
                >
                    <FilterAltOutlinedIcon />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        id="hub-usage-filter-title"
                        variant="h5"
                        component="h2"
                    >
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Choose which items to include.
                    </Typography>
                </Box>
                <IconButton
                    aria-label={`Close ${title}`}
                    onClick={onClose}
                    sx={{ mt: -0.75, mr: -1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent
                dividers
                sx={{ p: 2, backgroundColor: "background.default" }}
            >
                <Button
                    variant="outlined"
                    onClick={onToggleAll}
                    sx={{ mb: 1.5 }}
                >
                    {allSelected ? "Deselect all" : "Select all"}
                </Button>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.75,
                        maxHeight: 420,
                        overflow: "auto",
                    }}
                >
                    {items.map((item) => (
                        <ListItemButton
                            key={item.key}
                            onClick={() => onToggle(item.key)}
                            sx={{
                                borderRadius: 2,
                                border: "1px solid",
                                borderColor: "divider",
                                backgroundColor: "background.paper",
                            }}
                        >
                            <Checkbox
                                checked={selectedKeys.includes(item.key)}
                                tabIndex={-1}
                                disableRipple
                                sx={{ mr: 1 }}
                            />
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    sx: { fontWeight: 700 },
                                }}
                            />
                        </ListItemButton>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 1.5 }}>
                <Button variant="contained" disableElevation onClick={onClose}>
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
}
